import React, { memo } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as reportsActions from '../../store/actions/reports';
import { PlanActions } from '../../store/actions/plans';

import iconBack from '../../assets/images/back.svg';

import './index.css';
import TypePlan from '../../components/Plans/Plan/TypePlan';
import ActualPlan from '../../components/Plans/ActualPlan/ActualPlan';

function ViewPlans(props) {
  const { viewPage, plansSelect, setViewPage, company } = props;

  return (
    <div>
      <div
        className="volta-menu-principal"
        onClick={() => setViewPage('plano')}
      >
        <span className="simbolo-voltar pointer">
          <img src={iconBack} alt="Voltar" style={{ height: 19 }} />
        </span>
        <span>Plano</span>
      </div>
      <p className="title-plan-sector">Plano atual</p>
      <div className="container-plan-type-ds">
        <>
          <ActualPlan viewPage={viewPage} company={company} />
        </>
      </div>
      <p className="title-plans-available">Planos disponíveis</p>
      <div className="container-plan-type-ds container-plan-items">
        <>
          {plansSelect.map((plan) => (
            <TypePlan key={plan._id} plan={plan} />
          ))}
        </>
      </div>
    </div>
  );
}
const mapStateToProps = (state) => ({
  company: state.companies.company,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...reportsActions, ...PlanActions }, dispatch);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(memo(ViewPlans))
);
